import { vocabularize } from "src/Common/vocab";
import { getImageUrl } from "src/Common/common";
import { ActionMenu, ActionMenuIcon } from "src/Components/Common/ActionMenu";

const DraftOptions = ({
  onCreateWo,
  onEdit,
  onDuplicate,
  onDelete,
  onClose,
  canAssign = true,
  canEdit = true,
  canDuplicate = true,
  canDelete = true,
}) => {
  return (
    <ActionMenu onClose={onClose}>
      {canAssign && (
        <ActionMenuIcon
          onClick={onCreateWo}
          title={vocabularize("Assign WO")}
          src={getImageUrl("/images/common/wo.png")}
        />
      )}
      {canEdit && (
        <ActionMenuIcon onClick={onEdit} title="Edit" src={getImageUrl("/images/common/edit.png")} />
      )}
      {canDuplicate && (
        <ActionMenuIcon
          onClick={onDuplicate}
          title="Duplicate"
          src={getImageUrl("/images/common/white_duplicate.png")}
        />
      )}
      {canDelete && (
        <ActionMenuIcon
          onClick={onDelete}
          title="Delete"
          src={getImageUrl("/images/common/black_trash.png")}
        />
      )}
    </ActionMenu>
  );
};

export default DraftOptions;
